






































import Vue from 'vue'
import { DropdownGroupInterface, ListItem } from '@/config/interfaces'

export default Vue.extend({
  name: 'DropdownGroupEl',

  mounted () {
    this.selectedMaster = this.templateItemData.masterList[0]?.value
    this.selectedSlave = this.slaveList[0]?.value
  },

  data: () => ({
    slaveList: [] as Array<ListItem>,
    selectedMaster: '',
    selectedSlave: ''
  }),

  props: {
    templateItemData: {
      type: Object as () => DropdownGroupInterface,
      required: true
    }
  },
  methods: {
    updateValues (key: string): void {
      const filteredObject = Object.entries(this.templateItemData.slaveList.filter(value => value.masterKey === key))
      const filteredValues = Object.values(Object.fromEntries(filteredObject))
      this.slaveList = filteredValues.map(value => value.list)[0]
    }
  }
})

